// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   apiURL: "https://qa.api-digital.alicorp.com.pe/api",
//   ocpKey: "0401df6b287a45e0b1f51f45643db72b",
//   ACCOUNT_NAME: 'alieus2stadgtwclpepre03',
//   GTM_KEY: 'GTM-WWK5C54L',
//   appVersion: '0.1.0', // Actualiza manualmente
//   braze: {
//     apiKey: '55fdb294-dc82-4285-a0f4-9286aaa0bdbc',
//     endpoint: 'sdk.iad-07.braze.com'
//   }
// };

export const environment = {
  production: false,
  apiURL: 'https://dev.api-digital.alicorp.com.pe/api',
  ocpKey: 'f9ecb1a0672641a8b218ecc6f59f99c1',
  ACCOUNT_NAME: 'alieus2stadgtwclpedev03',
  CONTAINER_NAME: 'private-resources',
  GTM_KEY: 'GTM-WWK5C54L',
  appVersion: '0.1.0', //Actualiza manualmente
  braze: {
    apiKey: 'd17a0cbe-67aa-4d20-acec-83bff772e7be',
    endpoint: 'sdk.iad-07.braze.com'
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.